import type { AppContext } from 'next/app';

import { Config } from '@/api/csrf/config';

const RESPONSE_HEADER_NAME = 'x-sync-token';
const REQUEST_HEADER_NAME = 'x-csrf-token';
const CSRF_OPTIONS = {
    cookie: {
        name: '_bws',
        // Use __Host- prefix for enhanced security in production
        httpOnly: true,
        secure: process.env.NODE_ENV === 'production',
        sameSite: 'strict',
        path: '/',
        maxAge: 60 * 60 * 24, // 24 hours
    },
    token: {
        responseHeader: RESPONSE_HEADER_NAME,
    },
    // Exclude certain paths from CSRF protection
    excludePathPrefixes: ['/api/public/'],
    // This is an optional
    protectPathPrefixes: ['/api/share/upload-token', '/api/share/create-share-page'],
    // Only protect state-changing HTTP methods
    ignoreMethods: ['GET', 'HEAD', 'OPTIONS'],
    // Custom error responses
} as Config;

const getSyncTokenFromRequest = (res: AppContext['ctx']['res']) => {
    const syncToken = res?.getHeader?.(RESPONSE_HEADER_NAME) || '';
    return syncToken.toString();
};

export { CSRF_OPTIONS, REQUEST_HEADER_NAME, RESPONSE_HEADER_NAME };
